module.exports = __webpack_public_path__ + "img/img_bestpractices.557038e7.png";